import { SvgIcon } from "@/core/components/svgIcon/SvgIcon";
import "./MobileNav.scss";
import { setIsMobileNavOpen } from "@/core/store/app";
import { $unreadNotificationsCount } from "@/features/notifications";
import { $unreadConversationsCount } from "@/features/chat/store/chatStore";
import { useUnit } from "effector-react";
import { useCallback, useState } from "react";
import NotificationsModal from "../../sidebar/NotificationsModal";
import { Link } from "react-router-dom";

export const MobileNav = () => {
  const [unreadNotificationsCount] = useUnit([$unreadNotificationsCount]);

  const [unreadMessageCount] = useUnit([$unreadConversationsCount]);
  const [isNotificationsModalOpen, setIsNotificationsModalOpen] =
    useState(false);

  const handleNotificationsClick = useCallback(() => {
    setIsNotificationsModalOpen((prev) => !prev);
  }, []);

  const handleNotificationsClose = useCallback(() => {
    setIsNotificationsModalOpen(false);
  }, []);

  return (
    <div className="mobileNav">
      <div className="footer-items">
        <div className="footer-item" onClick={handleNotificationsClick}>
          <div className="footer-icon-wrapper">
            <SvgIcon icon="icon-bell" />
            {unreadNotificationsCount > 0 && (
              <div className="notification-badge">
                {unreadNotificationsCount}
              </div>
            )}
          </div>
        </div>
        <Link className="footer-item" to={"/messages"}>
          <div className="footer-icon-wrapper">
            <SvgIcon icon="icon-message" />
            {unreadMessageCount > 0 && (
              <div className="notification-badge">{unreadMessageCount}</div>
            )}
          </div>
        </Link>
      </div>

      <div className="burgerMenu" onClick={() => setIsMobileNavOpen(true)}>
        <SvgIcon icon="icon-burger" />
      </div>
      <NotificationsModal
        isOpen={isNotificationsModalOpen}
        onClose={handleNotificationsClose}
      />
    </div>
  );
};
